module.exports = __webpack_public_path__ + "static/media/main idea.3f7d1eaf.mp3";